import Heading from '@atlaskit/heading';
import { Anchor, Box, Inline, xcss } from '@atlaskit/primitives';
import { logoBase64 } from '@dev-agents/boysenberry-logo';

import { boysenberryPath } from '../../routes/paths';

const logoStyles = xcss({
	width: '32px',
	height: '32px',
	background: `url(${logoBase64}) no-repeat center center`,
	backgroundSize: 'contain',
});

const linkStyles = xcss({
	textDecoration: 'none',

	':hover': {
		textDecoration: 'none',
	},
	':focus': {
		textDecoration: 'none',
	},
	':visited': {
		textDecoration: 'none',
	},
});

export const Logo = () => (
	<Anchor href={boysenberryPath} xcss={linkStyles}>
		<Inline space="space.200" alignBlock="center">
			<Box xcss={logoStyles} />
			<Box>
				{/* eslint-disable-next-line @dev-agents/rules/i18n/text-wrapped-in-format-message */}
				<Heading size="small">Boysenberry</Heading>
			</Box>
		</Inline>
	</Anchor>
);
